import gql from 'graphql-tag'

export const CREATE_PICKUP_TICKET = gql`
  mutation CreatePickupTicket(
    $itemIds: [String!]!,
    $nonce: String!,
    $serviceLevel: String!,
    $scheduledAt: String!,
    $notes: String,
    $amount: Int!,

    $fromAddressId: String,
    $fromAddress: AddressInput
    $returnAddressId: String,
    $returnAddress: AddressInput
  ) {
    createPickupTicket(input: {
      params: {
        itemIds: $itemIds
        serviceLevel: $serviceLevel
        scheduledAt: $scheduledAt
        notes: $notes
        payment: {
          nonce: $nonce
          amountCents: $amount
        }
        fromAddressId: $fromAddressId
        fromAddress: $fromAddress
        returnAddressId: $returnAddressId
        returnAddress: $returnAddress
      }
    }) {
      ticket {
        type
        returnMethod
        confirmationCode
        id
        returnAddress {
          addressLine2
          city
          id
          name
          postalCode
          phoneNumber
          state
          stateCode
          street
          isResidential
          hasDoorman
        }
        items {
          id
          confirmationCode
          apparel {
            name
          }
          brand
          color
          material
          formattedPrice
          description
          options {
            id
            name
            formattedPrice
            minPrice
            maxPrice
            indefiniteMax
            category {
              id
              name
            }
          }
        }
      }
      errors
    }
}`

export const CREATE_DROPOFF_TICKET = gql`
  mutation CreateRepairTicket(
    $itemIds: [String!]!
  ) {
    createRepairTicket(input: {
      params: {
        itemIds: $itemIds
      }
    }) {
      ticket {
        type
        returnMethod
        confirmationCode
        id
        items {
          id
          confirmationCode
          apparel {
            name
          }
          brand
          color
          material
          formattedPrice
          description
          options {
            id
            name
            formattedPrice
            minPrice
            maxPrice
            indefiniteMax
            category {
              id
              name
            }
          }
        }
      }
      errors
    }
  }
`

export const CREATE_MAILIN_TICKET = gql`
  mutation CreateMailinTicket(
    $itemIds: [String!]!,
    $payment: PaymentInput,
    $serviceLevel: String!,
    $returnAddress: AddressInput,
    $returnAddressId: String,
    $isInsured: Boolean
  ) {
    createMailinTicket(input: {
      params: {
        itemIds: $itemIds,
        payment: $payment,
        serviceLevel: $serviceLevel,
        returnAddress: $returnAddress,
        returnAddressId: $returnAddressId,
        isInsured: $isInsured
      }
    })  {
      ticket {
        id
        type
        returnMethod
        confirmationCode
        returnAddress {
          id
          addressLine2
          city
          name
          postalCode
          phoneNumber
          state
          stateCode
          street
          isResidential
          hasDoorman
        }
        items {
          id
          confirmationCode
          apparel {
            id
            name
          }
          brand
          color
          material
          formattedPrice
          description
          options {
            id
            name
            formattedPrice
            minPrice
            maxPrice
            indefiniteMax
            category {
              id
              name
            }
          }
        }
      }
      errors
    }
  }
`

export const CREATE_REPAIR_ITEM = gql`
  mutation CreateRepairItem(
    $apparelId: String!,
    $brand: String!,
    $color: String!,
    $material: String!,
    $description: String,
    $additionalInformation: String,
    $picture: Upload,
    $optionsAttributes: [RepairItemOptionInput!]!,
    $isRush: Boolean
  ) {
    createRepairItem(input: {
      params: {
        apparelId: $apparelId
        brand: $brand
        color: $color
        material: $material
        description: $description
        additionalInformation: $additionalInformation
        picture: $picture
        optionsAttributes: $optionsAttributes,
        isRush: $isRush
      }
    }) {
      item {
        id
        apparel {
          name
        }
        brand
        color
        material
        photoUrl
        description
        additionalInformation
        confirmationCode
        needsConsultation
        isRush
        formattedPrice
        options {
          name
          minPrice
          maxPrice
          indefiniteMax
          comment
          category {
            id
            name
          }
        }
      }
      errors
    }
  }
`

export const CREATE_TICKET_PAYMENT = gql`
  mutation CreateTicketPayment(
    $ticketId: String!,
    $payment: PaymentInput!
  ) {
    createTicketPayment(input: {
      ticketId: $ticketId
      payment: $payment
    }) {
      ticket {
        id
        price
        amountPaid
        confirmationCode
        status
        formattedPrice
      }
      errors
    }
  }
`

export const CREATE_DELIVERY = gql`
  mutation CreateDelivery(
    $payment: PaymentInput!
    $ticketId: String
    $externalId: String
    $subtotal: Float!
    $shippingFee: Float!
    $returnAddressId: String
    $returnAddress: AddressInput
  ) {
    createDelivery(input: {
      params: {
        payment: $payment
        ticketId: $ticketId
        externalId: $externalId
        subtotal: $subtotal
        shippingFee: $shippingFee
        returnAddressId: $returnAddressId
        returnAddress: $returnAddress
      }
    }) {
      ticket {
        type
        returnMethod
        confirmationCode
        id
        returnAddress {
          addressLine2
          city
          id
          name
          postalCode
          phoneNumber
          state
          stateCode
          street
          isResidential
          hasDoorman
        }
        items {
          id
          confirmationCode
          apparel {
            name
          }
          brand
          color
          material
          formattedPrice
          description
          options {
            id
            name
            formattedPrice
            minPrice
            maxPrice
            indefiniteMax
            category {
              id
              name
            }
          }
        }
      }
      errors
    }
  }
`
